'use strict';

import modalDirective from 'brg/rest/buttons/modal';

import template from './template.html';

export default modalDirective({
	template: template,
});
